import React from 'react'
import RichTextEditor from '../../pb_rich_text_editor/_rich_text_editor'
import { useEditor, EditorContent } from "@tiptap/react"
import StarterKit from "@tiptap/starter-kit"


const RichTextEditorAdvancedRequiredIndicator = (props) => {

    const editor = useEditor({
        extensions: [StarterKit.configure({ trailingNode: false })],
        content:"Add your text here. You can format your text, add links, quotes, and bullets."
    })
      if (!editor) {
        return null
      }

  return (
    <div>
      <RichTextEditor
          advancedEditor={editor}
          id={"required-advanced"}
          label="Label"
          requiredIndicator
          {...props}
      >
        <EditorContent editor={editor}/>
      </RichTextEditor>
    </div>
  )
}

export default RichTextEditorAdvancedRequiredIndicator
